// @flow
import type { FSA } from 'types/redux';
import { API_REQUEST } from 'middlewares/api-middleware';


export const GET_CONFIG = 'GET_CONFIG';
export function getConfig(): FSA {
  return {
    type: GET_CONFIG,
    payload: {
      method: 'GET',
      url: '/configurations',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const SET_HAS_DETAILS_HEADER = 'SET_HAS_DETAILS_HEADER';
export function setHasDetailsHeader(hasHeader: boolean): FSA {
  return {
    type: SET_HAS_DETAILS_HEADER,
    payload: hasHeader,
  };
}
